import { StrictMode } from 'react'
import { AppProvider } from 'contexts/app/AppProvider'
import { AuthProvider } from 'contexts/auth/AuthProvider'
import { ThemeProvider } from 'contexts/theme/ThemeProvider'
import { createRoot } from 'react-dom/client'
import App from './App'

// When Chrome (or Safari) restores this tab from the back-forward cache
// (e.g. after closing the browser and reopening, or using back/forward
// navigation), the JS heap is restored along with any already-settled
// in-flight fetches. That leaves the app showing stale loaders and
// "failed" data even though the session is still valid. Force a full
// reload so every hook re-runs against a clean slate. This mirrors what
// a manual hard-refresh does today.
if (typeof window !== 'undefined') {
  window.addEventListener('pageshow', (event) => {
    const navEntry = performance.getEntriesByType?.('navigation')?.[0] as PerformanceNavigationTiming | undefined
    const isBackForward = event.persisted || navEntry?.type === 'back_forward'
    if (isBackForward) {
      window.location.reload()
    }
  })
}

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root container missing in index.html')
}

const root = createRoot(container)

root.render(
  <StrictMode>
    <AuthProvider>
      <AppProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </AppProvider>
    </AuthProvider>
  </StrictMode>
)
